"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 用户类型管理
var _default = exports.default = {
  getUserClassificationList: function getUserClassificationList(data, cancelToken) {
    return (0, _request.default)({
      url: '/protected/user-classification/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getUserClassificationDetail: function getUserClassificationDetail(id) {
    return (0, _request.default)({
      url: '/protected/user-classification/query/' + id,
      method: 'get'
    });
  },
  saveUserClassification: function saveUserClassification(data) {
    return (0, _request.default)({
      url: '/protected/user-classification/save',
      method: 'post',
      data: data
    });
  },
  deleteUserClassification: function deleteUserClassification(data) {
    return (0, _request.default)({
      url: '/protected/user-classification/delete',
      method: 'post',
      data: data
    });
  },
  queryUserClassification: function queryUserClassification(data) {
    return (0, _request.default)({
      url: '/protected/user-classification/query-system',
      method: 'post',
      data: data
    });
  }
};